import { GET_PROGRESS_REPORTS_BY_ID_SUCCESS, GET_PROGRESS_REPORTS_SUCCESS, SET_PROGRESS_REPORT_STATUS } from './progressReport.types';

const initialState = {
    progressReportList: [],
    progressReportById: null,
    // { [reportId]: status } saved since the report was loaded; wins over `progressReportById.status`.
    progressReportStatuses: {},
};

export const progressReportReducer = (state = initialState, action) => {
    switch (action.type) {
        /** ProgressReport */

        case GET_PROGRESS_REPORTS_SUCCESS:
            return {
                ...state,
                progressReportList: action.payload,
            };

        case GET_PROGRESS_REPORTS_BY_ID_SUCCESS: {
            // A fresh load is the server's word: drop what this tab saved before, or a report someone
            // else finalized since would still offer Save Draft (and fail with a 400).
            const progressReportStatuses = { ...state.progressReportStatuses };
            delete progressReportStatuses[action.payload?.id];
            return {
                ...state,
                progressReportById: action.payload,
                progressReportStatuses,
            };
        }

        case SET_PROGRESS_REPORT_STATUS:
            return {
                ...state,
                progressReportStatuses: { ...state.progressReportStatuses, [action.payload.id]: action.payload.status },
            };

        /** End */

        default:
            return state;
    }
};
